import fetchJSON from '@api/api_helper';

const getUrl = (orgKey) => `/api/v4/organizations/${orgKey}/printer_settings`;

export const get = (options, updateFetchControllers) => (
  fetchJSON(getUrl(options.organizationKey), options, updateFetchControllers)
    .then(({ data }) => (data))
);
